import type { Permission, PersonnelTmdPermission } from "src/api/Tmd.dtos";

const hasPermission = (
    personnelTmdPermissions: PersonnelTmdPermission[],
    permission: Permission,
    trialId?: number,
    institutionId?: number,
): boolean => {
    // Check the user has any permissions at all.
    if (personnelTmdPermissions && personnelTmdPermissions.length > 0) {
        // Check for permission on Trial Institution.
        if (
            (trialId || trialId === 0) && // has trial ID
            (institutionId || institutionId === 0) // has institution ID
        ) {
            if (
                personnelTmdPermissions.some(
                    (g) =>
                        g.trialMatch &&
                        g.trialId == trialId &&
                        g.institutionMatch &&
                        g.institutionId == institutionId &&
                        g.permission == permission,
                )
            ) {
                return true;
            }

            //check for a higher permission on the Trial
            if (
                personnelTmdPermissions.some(
                    (g) =>
                        g.trialMatch &&
                        g.trialId == trialId &&
                        !g.institutionMatch &&
                        g.permission == permission,
                )
            ) {
                return true;
            }
        }

        // Check for permission on Trial
        if (
            (trialId || trialId === 0) && // has trialId
            !institutionId &&
            institutionId !== 0 // does not have institution ID
        ) {
            if (
                personnelTmdPermissions.some(
                    (g) => g.trialMatch && g.trialId == trialId && g.permission == permission,
                )
            ) {
                return true;
            }
        }

        // Check for permission on Institution
        if (
            !trialId &&
            trialId !== 0 && // does not have trial ID
            (institutionId || institutionId === 0) // has institution ID
        ) {
            if (
                personnelTmdPermissions.some(
                    (g) =>
                        !g.trialMatch &&
                        g.institutionMatch &&
                        g.institutionId == institutionId &&
                        g.permission == permission,
                )
            ) {
                return true;
            }
        }

        // Check for global permission
        if (
            personnelTmdPermissions.some(
                (g) => !g.trialMatch && !g.institutionMatch && g.permission == permission,
            )
        ) {
            return true;
        }
    }

    return false;
};

export default hasPermission;
